const pendingImages = new WeakSet();

function checkImagesLoaded(container = document) {
  const images = container.querySelectorAll('img.track-loaded');

  images.forEach((image) => {
    if (image.complete) {
      image.classList.add('is-complete');
    } else if (!pendingImages.has(image)) {
      pendingImages.add(image);
      image.addEventListener('load', () => {
        image.classList.add('is-complete');
        pendingImages.delete(image);
      }, { once: true });
    }
  });
}

checkImagesLoaded();

document.addEventListener('shopify:section:load', (event) => {
  checkImagesLoaded(event.target);
});

document.addEventListener('switch:load:images', (e) => {
  const container = e.detail && e.detail.container ? e.detail.container : document;
  checkImagesLoaded(container);
});
